import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

const modalStyle = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
    padding: '0',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

export const Modal = ({ style, children, ...rest }) => (
  <ReactModal style={style ? style : modalStyle} {...rest}>
    {children}
  </ReactModal>
);

Modal.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object
};
